module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.5591/js/img/productIcons/Sales_Pro.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/productIcons/Sales_Pro.svg
// module id = 824
// module chunks = 5 6